import Handsontable from 'handsontable/base';
import { CellCoordsObj, CellRangeObj } from '../../../../../../common/table/TableTypes';
import { forEachCellInRange } from '../../selectionUtils/tableSelectionIterationUtils';
import { setHotTableCellMetaObject } from './hotTableCellMetaUtils';
import { MNHotInstance } from '../../../tableHotInstanceTypes';

type ApplyHotTableCellMetaInRangeArgs = {
    hotInstance: MNHotInstance;
    cellRange: CellRangeObj;
    getCellMeta: (cell: CellCoordsObj) => Partial<Handsontable.CellMeta>;
};

/**
 * Applies cell meta across a rectangular range on the active HOT instance.
 */
export const applyHotTableCellMetaInRange = ({
    hotInstance,
    cellRange,
    getCellMeta,
}: ApplyHotTableCellMetaInRangeArgs): void => {
    forEachCellInRange({
        cellRange,
        callback: ({ row, col }) => {
            setHotTableCellMetaObject(hotInstance, row, col, getCellMeta({ row, col }));
        },
    });
};
